<template>
    <div>
        <header>
            <div class="header-title">
                <p>黑名单列表</p>
            </div>
        </header>
        <div class="container">
            <div class="header-search">
                <p>
                    <span>主体名称/主体代码 : </span>
                    <el-input v-model="inputValue" placeholder="请输入" size="small" style="width: 240px" @clear="resetValue('inp')" clearable></el-input>
                </p>
                <p style="margin-left: 20px">
                    <span>状态 : </span>
                    <el-select v-model="changeStatus" placeholder="请选择" @clear="resetValue" size="small" clearable>
                        <el-option label="过期" value="0"></el-option>
                        <el-option label="部分暂停" value="1"></el-option>
                        <el-option label="全部暂停" value="2"></el-option>
                    </el-select>
                    <el-button size="small" style="margin-left: 10px" @click="searchData">搜索</el-button>
                    <el-button size="small" @click="openAddDialog('addRuleForm')">添加黑名单</el-button>
                    <el-button size="small" @click="searchData">刷新</el-button>
                </p>
            </div>
            <div class="card-item">
                <div class="card-content">
                    <el-table
                            v-loading="isLoading"
                            border
                            :data="tableList"
                            :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                        }">
                        <el-table-column
                                fixed
                                prop="date"
                                type="index"
                                label="序号"
                                align="center"
                                width="60px">
                            <template scope="scope">
                                <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                fixed
                                prop="date"
                                label="操作"
                                width="110px"
                                align="center">
                            <template scope="scope">
                                <div class="actionBox">
                                    <el-button type="text" @click="openSeeDialog(scope.row.id,'addRuleForm')">查看</el-button>
                                    <span class="mark"></span>
                                    <el-button type="text" @click="removeData(scope.row.id)">移除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="状态"
                                width="120"
                                align="center">
                            <template scope="scope">
                                <p type="text" v-if="scope.row.status == 0" class="change-examine"><i
                                        class="examine-invalid"></i><span>过期</span></p>
                                <p type="text" v-else-if="scope.row.status == 1" class="change-examine"><i
                                        class="examine-waitSubmit"></i><span>部分暂停</span></p>
                                <p type="text" v-else-if="scope.row.status == 2" class="change-examine"><i
                                        class="examine-no-verification"></i><span>全部暂停</span></p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="date"
                                align="center"
                                width="100"
                                label="主体大类">
                            <template scope="scope">
                                <p type="text">{{scope.row.entType == 1 ? '自然人' : scope.row.entType == 2 ? '法人' : scope.row.entType}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="entName"
                                align="center"
                                width="202"
                                label="主体名称">
                        </el-table-column>
                        <el-table-column
                                prop="uniqueCode"
                                align="center"
                                width="270px"
                                label="主体代码">
                        </el-table-column>
                        <el-table-column
                                prop="roleCodes"
                                label="交易主体类型"
                                width="250"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="successTime"
                                align="center"
                                width="174"
                                label="入库时间">
                        </el-table-column>
                        <el-table-column
                                prop="updateUser"
                                label="修改人"
                                width="130"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="updateTime"
                                label="修改时间"
                                width="174"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="createUser"
                                label="创建人"
                                width="130"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="createTime"
                                label="创建时间"
                                width="174"
                                align="center">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <el-dialog
                title="暂停业务"
                :visible.sync="addDialogVisible"
                width="45%">
            <el-form :model="addRuleForm" ref="addRuleForm" label-width="130px" class="demo-ruleForm">
                <el-form-item label="主体名称" prop="name" :rules="addRules.name">
                    <el-select v-model="addRuleForm.name" style="width: 645px;" size="small" v-el-select-loadmore="loadmore" :disabled="nameAble" filterable :filter-method="dataFilter" clearable placeholder="请选择主体名称">
                        <el-option v-for="(item,index) in nameList" :key="index" :label="item.name" :value="item.id+','+item.entType"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="type" :rules="addRules.type">
                    <el-checkbox-group v-model="addRuleForm.type" @change="checkboxChange">
                        <div v-for="(item,index) in addRuleForm.typeList" :key="index">
                            <el-checkbox :label="item.businessCode" name="type">{{item.businessName}}</el-checkbox>
                            <div v-if="checkList.includes(item.businessCode)">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="暂停开始时间 : "
                                                      :prop="`typeList.${index}.pauseStartTime`"
                                                      :rules="addRules.pauseStartTime"
                                                      size="small">
                                            <el-date-picker
                                                    v-model="item.pauseStartTime"
                                                    :picker-options="item.pickerOptionsStart"
                                                    @change="changeEnd(item.pauseStartTime,index)"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="请选择日期时间">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="暂停结束时间 : "
                                                      :prop="`typeList.${index}.pauseEndTime`"
                                                      :rules="addRules.pauseEndTime"
                                                      size="small">
                                            <el-date-picker
                                                    v-model="item.pauseEndTime"
                                                    :picker-options="item.pickerOptionsEnd"
                                                    @change="changeStart(item.pauseEndTime,index)"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="请选择日期时间">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col>
                                        <el-form-item label="暂停/调整原因 : "
                                                      :prop="`typeList.${index}.pauseCause`"
                                                      :rules="addRules.pauseCause"
                                                      size="small">
                                            <el-input type="textarea"
                                                      v-model="item.pauseCause"
                                                      max="100"
                                                      placeholder="请输入"
                                                      clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveAddData('addRuleForm',id)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        directives: {
            'el-select-loadmore': {
                bind(el, binding) {
                    // 获取element-ui定义好的scroll盒子
                    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
                    SELECTWRAP_DOM.addEventListener('scroll', function () {
                        /**
                         * scrollHeight 获取元素内容高度(只读)
                         * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                         * clientHeight 读取元素的可见高度(只读)
                         * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                         * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                         */
                        const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                        if (condition) {
                            binding.value();
                        }
                    });
                }
            }
        },
        data() {
            return {
                suspendList:[], // 回显数据
                isLoading:true, // 加载中
                checkList:[], // 选中的业务
                nameList:[], // 主体名称
                addRuleForm: {
                    name: '',
                    type: [],
                    typeList:[
                        {
                            businessCode:'57',
                            businessName:'建设工程',
                            pauseStartTime:'',
                            pauseEndTime:'',
                            pauseCause:'',
                            pickerOptionsStart: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            },// 暂停开始时间限制
                            pickerOptionsEnd: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            }, // 暂停结束时间限制
                        },
                        {
                            businessCode:'58',
                            businessName:'国有产权交易',
                            pauseStartTime:'',
                            pauseEndTime:'',
                            pauseCause:'',
                            pickerOptionsStart: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            },// 暂停开始时间限制
                            pickerOptionsEnd: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            }, // 暂停结束时间限制
                        },
                        {
                            businessCode:'59',
                            businessName:'限额以下项目交易',
                            pauseStartTime:'',
                            pauseEndTime:'',
                            pauseCause:'',
                            pickerOptionsStart: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            },// 暂停开始时间限制
                            pickerOptionsEnd: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            }, // 暂停结束时间限制
                        },
                        {
                            businessCode:'60',
                            businessName:'政府采购',
                            pauseStartTime:'',
                            pauseEndTime:'',
                            pauseCause:'',
                            pickerOptionsStart: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            },// 暂停开始时间限制
                            pickerOptionsEnd: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            }, // 暂停结束时间限制
                        },
                        {
                            businessCode:'61',
                            businessName:'国土交易',
                            pauseStartTime:'',
                            pauseEndTime:'',
                            pauseCause:'',
                            pickerOptionsStart: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            },// 暂停开始时间限制
                            pickerOptionsEnd: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            }, // 暂停结束时间限制
                        },
                        {
                            businessCode:'62',
                            businessName:'中介服务超市',
                            pauseStartTime:'',
                            pauseEndTime:'',
                            pauseCause:'',
                            pickerOptionsStart: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            },// 暂停开始时间限制
                            pickerOptionsEnd: {
                                disabledDate(time) {
                                    return time.getTime() < Date.now() - 8.64e7;
                                }
                            }, // 暂停结束时间限制
                        }
                    ], // 新增时的业务选择
                },
                addRules: {
                    name: [
                        { required: true, message: '请选择主体名称', trigger: 'change' }
                    ],
                    type: [
                        { required: true, message: '请选择要暂停的业务', trigger: 'change' }
                    ],
                    pauseStartTime: [
                        { required: true, message: '请选择暂停开始时间', trigger: 'change' }
                    ],
                    pauseEndTime: [
                        { required: true, message: '请选择暂停结束时间', trigger: 'change' }
                    ],
                    pauseCause: [
                        { required: true, message: '请输入暂停原因', trigger: 'blur' }
                    ]
                },
                addDialogVisible: false, // 添加黑名单
                inputValue: null,
                changeStatus: null,
                tableList: [],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                entType:'',
                entId:'',
                id:'',
                nameAble:false,
                formData: {
                    pageIndex: 1,
                    pageSize: 20,
                }
            }
        },
        created() {
            this.queryList();
        },
        activated() {
            this.queryList();
        },
        methods: {
            // 查询列表数据
            queryList(){
                this.$http.post('/sys-blacklist/list', {
                    page: this.currentPage,
                    rows: this.pageSize,
                    filter: {
                        status: !!this.changeStatus ? Number(this.changeStatus) : this.changeStatus
                    },
                    searchKey: this.inputValue,
                    orderBy: 'create_time desc'
                }).then((res) => {
                    if (res.data) {
                        this.tableList = res.data.data.rows;
                        this.total = res.data.total;
                        this.isLoading = false;
                    }else{
                        this.isLoading = true;
                    }
                })
            },
            // 搜索
            searchData(){
                this.currentPage = 1;
                this.queryList();
            },
            // 清空列表数据
            resetValue(inp){
                if(inp){
                    this.inputValue = null;
                }else{
                    this.changeStatus = null;
                }

            },
            // 监听选中的暂停业务
            checkboxChange(value){
                this.checkList = value;
            },
            // 主体信息懒加载
            loadmore() {
                this.formData.pageIndex++;
                this.getUserList();
            },
            // 查询主体名称
            getUserList(filter){
                this.$http.post('/sys-blacklist/dropdown',{
                    page: this.formData.pageIndex,
                    rows: this.formData.pageSize,
                    searchKey: this.addRuleForm.name
                }).then((res)=>{
                    if(res.data && res.data.code == 1){
                        if(filter){
                            this.nameList = res.data.data.rows;
                        }else{
                            this.nameList = [...this.nameList,...res.data.data.rows];
                        }
                    }
                });
            },
            dataFilter(val) {
                if (val) {
                    this.addRuleForm.name = val;
                    this.formData.pageIndex = 1;
                    this.getUserList('filter');
                }else{
                    this.formData.pageIndex = 1;
                    this.formData.pageSize = 20;
                    this.addRuleForm.name = '';
                    this.nameList = [];
                    this.getUserList();
                }
            },
            // 添加黑名单
            openAddDialog(){
                this.addDialogVisible = true; // 弹框显示
                this.pickerOptionsStart = {};// 暂停开始时间限制
                this.pickerOptionsEnd = {}; // 暂停结束时间限制
                this.suspendList = []; // 因为和查看使用的同一个弹框，这里需要把回显的数据清空
                this.addRuleForm.name = ''; // 初始化主体名称
                this.entType = ''; // 初始化主体类型
                this.entId = '';// 初始化主体Id
                this.id = '';// 初始化当前数据id
                this.checkList = [];// 初始化选中的业务
                this.addRuleForm.type = [];// 初始化业务选择的校验
                this.addRuleForm.typeList =[
                    {
                        businessCode:'57',
                        businessName:'建设工程',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    },
                    {
                        businessCode:'58',
                        businessName:'国有产权交易',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    },
                    {
                        businessCode:'59',
                        businessName:'限额以下项目交易',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    },
                    {
                        businessCode:'60',
                        businessName:'政府采购',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    },
                    {
                        businessCode:'61',
                        businessName:'国土交易',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    },
                    {
                        businessCode:'62',
                        businessName:'中介服务超市',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    }
                ], // 因为和查看使用的同一个弹框，这里需要初始化一下否则回显值会附上去
                this.nameAble = false;
                this.formData.pageIndex = 1;
                this.formData.pageSize = 20;
                this.nameList = [];
                this.getUserList();
            },
            // 保存添加黑名单
            saveAddData(formName,id){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // 查看（更新黑名单）
                        if(!!this.entType){
                            this.$http.put(`/sys-blacklist/${id}`, {
                                entId: this.entId,
                                entType: this.entType,
                                businesses:this.addRuleForm.typeList.filter((item,index)=>{
                                    return this.checkList.includes(item.businessCode) && !!item.pauseCause
                                })
                            }).then((res) => {
                                if(res.data && res.data.code == 1){
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'success'
                                    });
                                    this.queryList();
                                }else{
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'warning'
                                    });
                                }
                                this.$refs[formName].resetFields();
                            });
                            this.addDialogVisible = false;
                        }else{
                            // 添加黑名单
                            this.$http.post('/sys-blacklist/join', {
                                entId: this.addRuleForm.name.split(',')[0],
                                entType: Number(this.addRuleForm.name.split(',')[1]),
                                businesses:this.addRuleForm.typeList.filter((item,index)=>{
                                    return !!item.pauseCause
                                })
                            }).then((res) => {
                                if(res.data && res.data.code == 1){
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'success'
                                    });
                                    this.queryList();
                                }else{
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'warning'
                                    });
                                }
                                this.$refs[formName].resetFields();
                            });
                            this.addDialogVisible = false;
                        }
                    }
                })
            },
            // 查看黑名单
            openSeeDialog(id){
                this.addDialogVisible = true;
                this.pickerOptionsStart = {};// 暂停开始时间限制
                this.pickerOptionsEnd = {}; // 暂停结束时间限制
                this.suspendList = [];
                this.entType = '';
                this.entId = '';
                this.id = '';
                this.checkList = [];
                this.addRuleForm.type = [];
                this.addRuleForm.typeList =[
                    {
                        businessCode:'57',
                        businessName:'建设工程',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    },
                    {
                        businessCode:'58',
                        businessName:'国有产权交易',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    },
                    {
                        businessCode:'59',
                        businessName:'限额以下项目交易',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    },
                    {
                        businessCode:'60',
                        businessName:'政府采购',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    },
                    {
                        businessCode:'61',
                        businessName:'国土交易',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    },
                    {
                        businessCode:'62',
                        businessName:'中介服务超市',
                        pauseStartTime:'',
                        pauseEndTime:'',
                        pauseCause:'',
                        pickerOptionsStart: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        },// 暂停开始时间限制
                        pickerOptionsEnd: {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }, // 暂停结束时间限制
                    }
                ], // 因为和查看使用的同一个弹框，这里需要初始化一下否则回显值会附上去
                    this.nameAble = true;
                this.$http.get(`/sys-blacklist/business/${id}`).then((res)=>{
                    if(res.data && res.data.code == 1){
                        this.suspendList = res.data.data;
                        this.addRuleForm.name = res.data.data[0].entName;
                        this.entType = res.data.data[0].entType;
                        this.entId = res.data.data[0].entId;
                        this.id = id;
                    }
                    this.suspendList.map((item,index)=>{
                        this.addRuleForm.typeList.map((i,x)=>{
                            if(item.businessCode == i.businessCode){
                                i.businessCode = item.businessCode;
                                i.businessName = item.businessName;
                                i.pauseCause = item.pauseCause;
                                i.pauseEndTime = item.pauseEndTime;
                                i.pauseStartTime = item.pauseStartTime;
                                i.id = item.id;
                                this.checkList.push(item.businessCode);
                                this.addRuleForm.type.push(item.businessCode);
                            }
                        })
                    })
                })
            },
            // 移除
            removeData(id){
                this.$http.delete(`/sys-blacklist/${id}`).then((res)=>{
                    if(res.data && res.data.code == 1){
                        this.$notify({
                            title: '移除数据',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'success'
                        })
                    }else{
                        this.$notify({
                            title: '移除数据',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'warning'
                        })
                    }
                    this.queryList();
                })
            },
            // 结束时间限制开始时间
            changeStart(endTime,index) {
                let newEndTime = new Date(endTime);
                if (!endTime) {
                    this.addRuleForm.typeList[index].pickerOptionsStart = {
                        disabledDate(time) {
                            return time.getTime() < Date.now() - 8.64e7;
                        }
                    }
                    return
                }
                this.addRuleForm.typeList[index].pickerOptionsStart = Object.assign({}, this.addRuleForm.typeList[index].pickerOptionsStart, {
                    // 可通过箭头函数的方式访问到this
                    disabledDate: (time) => {
                        var times = ''
                        times = time.getTime() > newEndTime.getTime() || time.getTime() < Date.now() - 8.64e7;
                        return times
                    }
                })
            },
            // 开始时间 控制结束时间
            changeEnd(startTime,index) {
                let newStartTime = new Date(startTime);
                if (!startTime) {
                    this.addRuleForm.typeList[index].pickerOptionsEnd = {
                        disabledDate(time) {
                            return time.getTime() < Date.now() - 8.64e7;
                        }
                    }
                    return
                }
                this.addRuleForm.typeList[index].pickerOptionsEnd = Object.assign({}, this.addRuleForm.typeList[index].pickerOptionsEnd, {
                    disabledDate: (time) => {
                        return time.getTime() < newStartTime.getTime()
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 220px;
    }
    /deep/ .el-form-item:nth-child(2){
        .el-form-item__content{
            margin-left: 35px !important;
            .el-checkbox-group{
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
            }
        }
    }
    /deep/ .el-checkbox+.el-checkbox{
        margin-left: 0;
    }
    /deep/ .el-textarea {
        width: 610px;
    }
    /deep/ .el-textarea__inner {
        width: 610px;
        height: 80px;
    }

    header {
        height: 68px;
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        .header-title {
            p {
                font-size: 18px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
                margin-left: 32px;
                padding-top: 20px;
            }
        }
    }

    .container {
        margin: 20px;

        .header-search {
            width: 100%;
            height: 80px;
            background: #fff;
            margin-bottom: 20px;
            line-height: 80px;
            padding: 0 20px;
            display: flex;
            /deep/ .el-input--suffix{
                height: 55px;
            }
        }
        .card-content{
            .actionBox{
                display: flex;
                justify-content: space-around;
                align-items: center;
                .mark{
                    width: 1px;
                    height: 14px;
                    background: #409EFF;
                }
            }
        }
    }
</style>
